export const MAP_SETTINGS_SEARCH_SET_FILTER_BY = 'MAP_SETTINGS_SEARCH/SET_FILTER_BY';
export const MAP_SETTINGS_SEARCH_SET_SEARCH_SETTINGS = 'MAP_SETTINGS_SEARCH/SET_SEARCH_SETTINGS';
